/* Keyboard and status behaviour shared by AQUON's custom sections. */
(function () {
  'use strict';
  function init(scope) {
    // Purchase radios and dialogs are owned by aquon-purchase-ui.js.
    scope.querySelectorAll('[data-apdp-toast], [data-aqbp-toast]').forEach(function (el) { el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); });
  }
  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {}, cart = detail.resource || {};
    var count = typeof cart.item_count === 'number' ? cart.item_count : detail.data && detail.data.itemCount;
    if (typeof count !== 'number' || (detail.data && detail.data.isIncremental)) return;
    document.querySelectorAll('[data-aquon-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
